(async function() {
  const lang = document.documentElement.getAttribute('lang');
  const translations = await fetch("//shop.basefood.hk/cdn/shop/t/86/assets/translations.json?v=121618171513789595601773622423").then(res => res.json());
  const t = (key) => translations[lang][key];
  let modal = '';

  const translate = (parent, selector, key, attribute = 'innerHTML') => {
    const el = parent.querySelector(selector);

    if (el) {
      if (typeof key === 'string') {
        el[attribute] = t(key);
      }
      else {
        el[attribute] = t(key(el));
      }
    }
  }

  const setModal = (parent, selector, name) => {
    const el = parent.querySelector(selector);

    if (el) {
      el.addEventListener('click', () => {
        modal = name;
      })
    }
  }

  // translate my page 
  const translateList = () => {
    const title = document.querySelector('#mikawaya-subscription-list-title :first-child');

    if (title) {
      title.childNodes[1].textContent = t('title');
    }

    const items = document.querySelectorAll('.mikawaya-main-container > div > [id^=mikawaya-subscription-list-item]');
    translate(document, '.mikawaya-main-container > div > .chakra-text', 'header');

    items.forEach((item) => {
      // product name
      translate(item, '[id^=mikawaya-subscription-list-item-detail-name] :first-child', 'subscriptionGroupName');
      // next order date
      translate(item, '[id^=mikawaya-subscription-list-item-detail-next-order-date] :first-child', 'nextOrderDate');
      // status
      translate(item, '[id^=mikawaya-subscription-list-item-detail-status] :first-child', 'status');
      // status value
      translate(item, '[id^=mikawaya-subscription-list-item-detail-status] :nth-child(2)', (el) => {
        if (el.innerHTML.toLowerCase().includes('cancel')) {
          return 'cancel';
        }
        else if (el.innerHTML.toLowerCase().includes('inactive')) {
          return 'paused';
        }
        else {
          return 'active';
        }
      });
      // manage subscription button
      translate(item, '[id^=mikawaya-subscription-list-item-bottom] button', 'manageSubscriptions');
    });
  }

  // translate details
  const translateDetails = () => {
    const back = document.querySelector('#mikawaya-subscription-lines-back-button');

    if (back) {
      back.childNodes[1].textContent = t('backToList');
    }

    // box header
    translate(document, '#mikawaya-subscription-lines-product-title :first-child', 'items');
    const history = document.querySelector('#mikawaya-subscription-lines-order-history');
    // history header
    if (history) {
      history.previousSibling.innerHTML = t('orderHistory');
    }
  }

  // translate box details
  const translateBox = () => {
    const box = document.querySelector('#mikawaya-subscription-lines-items-box');

    if (box) {
      // product name
      translate(box, '[id^=mikawaya-subscription-lines-item-detail-name] :first-child', 'productName');
      // change button
      translate(box, '[id^=mikawaya-subscription-lines-item-detail-name] .chakra-text:nth-child(3) :first-child', 'change');
      setModal(box, '[id^=mikawaya-subscription-lines-item-detail-name] .chakra-text:nth-child(3) :first-child', 'changeProduct');
      // price
      translate(box, '[id^=mikawaya-subscription-lines-item-detail-value] :first-child', 'price');
      // quantity
      translate(box, '[id^=mikawaya-subscription-lines-item-detail-count] :first-child', 'quantity');
    }
  }

  const translateLineItems = () => {
    const items = document.querySelector('#mikawaya-subscription-lines-items');

    if (items) {
      items.childNodes.forEach((item) => {
      // product name
      translate(item, '[id^=mikawaya-subscription-lines-item-detail-name] :first-child', 'productName');
      // price
      translate(item, '[id^=mikawaya-subscription-lines-item-detail-value] :first-child', 'price');
      // quantity
      translate(item, '[id^=mikawaya-subscription-lines-item-detail-count] :first-child', 'quantity');
      })
    }
  }

  // translate coupon section
  const translateCoupon = () => {
    const coupon = document.querySelector('#mikawaya-subscription-lines-coupon');

    if (coupon) {
      // header
      coupon.previousSibling.innerHTML = t('discountCode');
      // textbox
      translate(coupon, '[name="coupon"]', 'couponCode', 'placeholder');
      // apply button
      translate(coupon, '[id^=mikawaya-subscription-lines-coupon-bottom] button', 'apply');
    }
  }

  // translate contract section
  const translateContract = () => {
    const contract = document.querySelector('#mikawaya-subscription-lines-contract');

    if (contract) {
      // header
      contract.previousSibling.innerHTML = t('scheduleContractStatus');
      // status
      translate(contract, '#mikawaya-subscription-lines-contract-title :first-child', 'contractStatus');
      // status value
      translate(contract, '#mikawaya-subscription-lines-contract-value :first-child', (el) => {
        if (el.innerHTML.toLowerCase().includes('cancel')) {
          return 'cancel';
        }
        else if (el.innerHTML.toLowerCase().includes('inactive')) {
          return 'paused';
        }
        else {
          return 'active';
        }
      });
      // next payment date
      translate(contract, '#mikawaya-subscription-lines-contract-payment-date-title :first-child', 'nextPaymentDate');
      // order cycle
      translate(contract, '#mikawaya-subscription-lines-contract-period-title :first-child', 'orderCycle');
      // minimum cycle
      translate(contract, '#mikawaya-subscription-lines-contract-min-order-count-title :first-child', 'minimumCycle');
      // change button
      translate(contract, '#mikawaya-subscription-lines-delivery-bottom :first-child', 'change');
      setModal(contract, '#mikawaya-subscription-lines-delivery-bottom :first-child', 'calendar');
      // skip button
      translate(contract, '#mikawaya-subscription-lines-delivery-bottom :nth-child(2)', 'skip');
      setModal(contract, '#mikawaya-subscription-lines-delivery-bottom :nth-child(2)', 'skip');
      // change cycle button
      translate(contract, '#mikawaya-subscription-lines-contract-bottom button', 'changeCycle');
      setModal(contract, '#mikawaya-subscription-lines-contract-bottom button', 'changeCycle');
    }
  }

  // translate address section
  const translateAddress = () => {
    const address = document.querySelector('#mikawaya-subscription-lines-delivery-address');

    if (address) {
      // header
      address.previousSibling.innerHTML = t('shippingAddress');
      // change button
      translate(address, '#mikawaya-subscription-lines-delivery-address-bottom button', 'change');
      setModal(address, '#mikawaya-subscription-lines-delivery-address-bottom button', 'address');
    }
  }

  // translate payment section
  const translatePayment = () => {
    const payment = document.querySelector('#mikawaya-subscription-lines-payment');

    if (payment) {
      // header
      payment.previousSibling.innerHTML = t('paymentMethod');
      // credit card
      translate(payment, '#mikawaya-subscription-lines-payment-way :first-child', 'creditCard');
      // change button
      translate(payment, '#mikawaya-subscription-lines-payment-bottom button', 'change');
      setModal(payment, '#mikawaya-subscription-lines-payment-bottom button', 'payment');
      // payment
      translate(payment, '#mikawaya-subscription-lines-payment-retry-payment button', 'paymentRetry');
      setModal(payment, '#mikawaya-subscription-lines-payment-retry-payment button', 'paymentRetry');
    }
  }
  
  // translate payment retry confirm modal
  const translatePaymentRetryModal = (el)=> {
    // header
    translate(el, '.chakra-modal__header', 'paymentRetryHeader');
    // cancel button
    translate(el, '.chakra-modal__footer button:first-child', 'paymentRetryCancel');
    // confirm button
    translate(el, '.chakra-modal__footer button:nth-child(2)', 'paymentRetryConfirm');
  }

  // translate history
  const translateHistory = () => {
    const history = document.querySelector('#mikawaya-subscription-lines-order-history');

    if (history) {
      // header
      history.previousSibling.innerHTML = t('orderHistory');
      // date/time
      translate(history, '#mikawaya-subscription-lines-order-history table td:first-child p:first-child', 'dateTime');
      // order number
      translate(history, '#mikawaya-subscription-lines-order-history table td:first-child p:nth-child(2)', 'orderNo');
    }
  }

  // translate buttons
  const  translateButtons = () => {
    const buttons = document.querySelector('#mikawaya-subscription-lines-pause-resume');

    if (buttons) {
      // pause/resume button
      const button = buttons.querySelector('li:first-child button');

      if (button) {
        if (button.textContent === '再開') {
          translate(buttons, 'li:first-child button', 'resume');
          setModal(buttons, 'li:first-child button', 'resume');
        }
        else {
          translate(buttons, 'li:first-child button', 'pause');
          setModal(buttons, 'li:first-child button', 'pause');
        }
      }

      // cancel button
      translate(buttons, 'li:nth-child(2) button', 'cancelRecurringPurchase');
      setModal(buttons, 'li:nth-child(2) button', 'cancelRecurringPurchase');
      // back button
      translate(document, '#mikawaya-subscription-lines-bottom-back button', 'back')
    }
  }

  // translate calendar modal
  const translateCalendarModal = (el) => {
    // header
    translate(el, '.chakra-modal__header', 'calendarHeader');
    // cancel button
    translate(el, '.chakra-modal__footer button:first-child', 'calendarCancel');
    // update button
    translate(el, '.chakra-modal__footer button:nth-child(2)', 'calendarUpdate');
  }

  // translate skip modal
  const translateSkipModal = (el) => {
    // header
    translate(el, '.chakra-modal__header', 'skipHeader');
    // cancel button
    translate(el, '.chakra-modal__footer button:first-child', 'skipCancel');
    // skip button
    translate(el, '.chakra-modal__footer button:nth-child(2)', 'skipConfirm');
  }

  // translate change cycle
  const translateChangeCycleModal = (el) => {
    // header
    translate(el, '.chakra-modal__body :first-child', 'changeCycleHeader');
    // select option
    translate(el, '.chakra-modal__body .chakra-select option:nth-child(1)', 'changeCycleDay');
    translate(el, '.chakra-modal__body .chakra-select option:nth-child(2)', 'changeCycleWeek');
    translate(el, '.chakra-modal__body .chakra-select option:nth-child(3)', 'changeCycleMonth');
    // cancel button
    translate(el, '.chakra-modal__footer button:nth-child(1)', 'changeCycleCancel');
    // confirm button
    translate(el, '.chakra-modal__footer button:nth-child(2)', 'changeCycleConfirm');
  }

  // translate address modal
  const translateAddressModal = (el) => {
    // last name
    translate(el, '.chakra-modal__body div:nth-child(2) div:first-child :first-child', 'lastName');
    // first name
    translate(el, '.chakra-modal__body div:nth-child(2) div:nth-child(2) :first-child', 'firstName');
    // country
    translate(el, '.chakra-modal__body div:nth-child(2) div:nth-child(3) :first-child', 'country');
    // postal code
    translate(el, '.chakra-modal__body div:nth-child(2) div:nth-child(4) :first-child', 'postalCode');
    // prefecture
    translate(el, '.chakra-modal__body div:nth-child(2) div:nth-child(5) :first-child', 'prefecture');
    // city
    translate(el, '.chakra-modal__body div:nth-child(2) div:nth-child(6) :first-child', 'city');
    // address
    translate(el, '.chakra-modal__body div:nth-child(2) div:nth-child(7) :first-child', 'address');
    // building, room number
    translate(el, '.chakra-modal__body div:nth-child(2) div:nth-child(8) :first-child', 'buildingRoomNo');
    // cancel
    translate(el, '.chakra-modal__body div:nth-child(2) div:nth-child(9) button:first-child', 'addressCancel');
    // update
    translate(el, '.chakra-modal__body div:nth-child(2) div:nth-child(9) button:nth-child(2)', 'addressUpdate');
  }

  // translate payment modal
  const translatePaymentModal = (el) => {
    // header
    translate(el, '.chakra-modal__body :first-child', 'paymentHeader');
    // cancel
    translate(el, '.chakra-modal__footer button:first-child', 'paymentCancel');
    // send
    translate(el, '.chakra-modal__footer button:nth-child(2)', 'paymentSend');
  }

  const translatePauseModal = (el) => {
    // skip next header
    const skipHeader = el.querySelector('.chakra-modal__header :first-child');
    if (skipHeader) {
      skipHeader.childNodes[0].textContent = t('pauseSkipHeader');
    }

    // skip next button
    translate(el, '.chakra-modal__header button', 'pauseSkipNext');
    setModal(el, '.chakra-modal__header button', 'skipNext');

    // header
    const header = el.querySelector('.chakra-modal__header');
    if (header) {
      header.childNodes[1].textContent = t('pauseHeader');
    }

    // text
    translate(el, '.chakra-modal__body', 'pauseText');
    // cancel button
    translate(el, '.chakra-modal__footer button:first-child', 'pauseCancel');
    // pause button
    const pauseConfirmButton = el.querySelector('.chakra-modal__footer button:nth-child(2)');
    pauseConfirmButton.classList.add('pause-modal-confirm');
    setModal(el, '.chakra-modal__footer button:nth-child(2)', 'pauseConfirmClick');
    // translate(el, '.chakra-modal__footer button:nth-child(2)', 'pauseConfirm');
  }

  const translateSkipNextModal = (el) => {
    // header
    translate(el , '.chakra-modal__header', 'skipNextHeader');
    // cancel button
    translate(el , '.chakra-modal__footer button:nth-child(1)', 'skipNextCancel');
    // skip button
    translate(el , '.chakra-modal__footer button:nth-child(2)', 'skipNextConfirm');
  }

  // translate bundler main content
  const translateBundler = (el) => {
    // header
    translate(el, ':first-child .chakra-text', 'bundlerHeader');
    // option 1 
    translate(el, 'select option:nth-child(1)', 'bundlerPlan1');
    // option 2
    translate(el, 'select option:nth-child(2)', 'bundlerPlan2');
    // remove button
    el.querySelectorAll('.css-1i7hjs0 button:first-child').forEach((button) => {
      button.childNodes[1].textContent = t('bundlerRemove');
    });
    // add button
    el.querySelectorAll('.css-1i7hjs0 button:nth-child(3)').forEach((button) => {
      button.childNodes[1].textContent = t('bundlerAdd');
    });
  }
  // translate bundle footer

  const translateBundlerFooter = (el) => {
    // error
    translate(el, '.chakra-text:first-child', 'bundlerError');
    // next button
    translate(el, 'button', 'bundlerButton');
  }

  // translate header in the change product modal
  const translateChangeProductModal = (el) => {
    translate(el, '#mikawaya-subscription-set-product-selection-header-title', 'changeProductHeader');
    translateChangeProductModalText();
  }

  // translate text in the change product modal
  const translateChangeProductModalText = () => {
    translate(document, '#mikawaya-subscription-set-product-selection-header-description', 'changeProductText');
  }

  // translate products in the change product modal
  const translateChangeProductModalProducts = (el) => {
    const products = el.querySelectorAll('[id^=mikawaya-subscription-set-product-selection-item]');

    products.forEach((product) => {
      // quantity
      translate(product, ':nth-child(3) > :first-child > :first-child > :first-child > :first-child', 'changeProductQuantity');
      // remove
      translate(product, ':nth-child(3) > :first-child > :first-child > :nth-child(3) > :first-child', 'changeProductRemove');
      setModal(product, ':nth-child(3) > :first-child > :first-child > :nth-child(3) > :first-child', 'changeProductRemove');
      // add
      translate(product, ':nth-child(3) > :first-child > :first-child > :nth-child(4) > :first-child', 'changeProductAdd');
    });
  }

  // translate apply button in change product modal
  const translateChangeProductModalButton = (el) => {
    //translate(el, '#mikawaya-subscription-set-product-selection-apply', 'changeProductApply')
    el.querySelector('#mikawaya-subscription-set-product-selection-apply').classList.add('change-product-apply');

    setModal(el, '#mikawaya-subscription-set-product-selection-apply', 'changeProductApply');
  }

  // translate error message
  const translateError = (el) => {
    el.childNodes[1].textContent = t('changeProductError');
  }

  // translate change product modal confirmation
  const translateChangeProductModalApply = (el) => {
    // header
    translate(el, '.chakra-modal__header', 'changeProductConfirmHeader');
    // cancel button
    translate(el, '.chakra-modal__footer button:first-child', 'changeProductConfirmCancel');
    // confirm button
    el.querySelector('.chakra-modal__footer button:nth-child(2)').classList.add('change-product-modal-apply');
    // translate(el, '.chakra-modal__footer button:nth-child(2)', 'changeProductConfirm');
  }

  // translate cancel recurring purchase modal
  const translateCancelRecurringPurchaseModal = (el) => {
    // skip next delivery header
    el.querySelector('.chakra-modal__header :first-child').childNodes[0].textContent = t('skipNextDeliveryHeader');
    // skip next delivery button
    translate(el, '.chakra-modal__header button', 'skipNextDelivery');
    setModal(el, '.chakra-modal__header button', 'skipNextDelivery');
    // cancel header
    el.querySelector('.chakra-modal__header').childNodes[1].textContent = t('cancelHeader');
    // cancel text
    translate(el, '.chakra-modal__body :first-child :first-child', 'cancelText');
    // cancel reason header
    translate(el, '.chakra-modal__body :first-child :nth-child(2)', 'cancelReasonHeader');

    // cancel reasons
    const reasons = el.querySelectorAll('.chakra-radio-group .chakra-radio');
    reasons.forEach((reason, index) => {
      translate(reason, '.chakra-radio__label', `cancelReason${index + 1}`);
    });

    // cancel button
    translate(el, '.chakra-modal__footer button:first-child', 'cancelButton');
    // confirm button
    translate(el, '.chakra-modal__footer button:nth-child(2)', 'cancelConfirm');
  }

  // translate skip next deliver modal
  const translateSkipNextDeliveryModal = (el) => {
    // header
    translate(el, '.chakra-modal__header', 'skipDeliveryModalHeader');
    // cancel button
    translate(el, '.chakra-modal__footer button:first-child', 'skipDeliveryModalCancel');
    // skip button
    translate(el, '.chakra-modal__footer button:nth-child(2)', 'skipDeliveryModalSkip');
  }

  const translateResumeModal = (el) => {
    translate(el, '.chakra-modal__header', 'resumeHeader');
    translate(el, '.chakra-modal__footer button:first-child', 'resumeCancel');
    //translate(el, '.chakra-modal__footer button:nth-child(2)', 'resumeConfirm');
    const resumeConfirmButton = el.querySelector('.chakra-modal__footer button:nth-child(2)');
    resumeConfirmButton.classList.add('resume-modal-confirm');
    setModal(el, '.chakra-modal__footer button:nth-child(2)', 'resumeConfirm');
  }

  const container = document.querySelector('.mikawaya-main-container');

  if (container) {
    const observer = new MutationObserver((entries) => {
      entries.forEach((e) => {
        e.addedNodes.forEach((el) => {
          if (el.nodeName !== '#text') {
            const loading = document.querySelector('.mikawaya-main-container > span');

            if (loading){
              loading.innerHTML = t('loading');
            }


            if (window.location.href.includes('/apps/floor-s/subscription')) {
              if (el.classList.contains('chakra-container')) {
                translateDetails();
                translateLineItems();
                translateCoupon();
                translateContract();
                translateAddress();
                translatePayment();
                translateButtons();
              }
              else if (el.id === 'mikawaya-subscription-lines-items-box') {
                translateBox();
              }
              else if (el.nodeName.toLowerCase() === 'tr') {
                translateHistory();
              }
              else if (el.classList.contains('chakra-portal')) {
                switch (modal) {
                  case 'calendar':
                    translateCalendarModal(el);
                    break;
                  case 'skip':
                    translateSkipModal(el);
                    break;
                  case 'changeCycle':
                    translateChangeCycleModal(el);
                    break;
                  case 'address':
                    translateAddressModal(el);
                    break;
                  case 'payment':
                    translatePaymentModal(el);
                    break;
                  case 'pause':
                    translatePauseModal(el);
                    break;
                  case 'skipNext':
                    translateSkipNextModal(el);
                    break;
                  case 'changeProduct':
                    translateChangeProductModal(el);
                    break;
                  case 'changeProductApply':
                    translateChangeProductModalApply(el);
                    break;
                  case 'cancelRecurringPurchase':
                    translateCancelRecurringPurchaseModal(el);
                    break;
                  case 'skipNextDelivery':
                    translateSkipNextDeliveryModal(el);
                    break;
                  case 'paymentRetry':
                    translatePaymentRetryModal(el);
                    break;
                  case 'resume':
                    translateResumeModal(el);
                    break;
                  default:
                    //console.log('modal');
                    //console.log(el);
                    break;
                }

                modal = '';
              }
              else if (el.querySelector('[id^=mikawaya-subscription-set-product-selection-item]')) {
                translateChangeProductModalProducts(el);
              }
              else if (el.querySelector('#mikawaya-subscription-set-product-selection-apply')) {
                translateChangeProductModalButton(el);
              }
              else if (el.id === 'mikawaya-subscription-set-product-selection-header-description') {
                translateChangeProductModalText(el);
              }
              else if (el.classList.contains('chakra-alert')) {
                switch(modal) {
                  case 'changeProductRemove':
                    translateError(el);
                    break;
                  default: 
                    //console.log('alert');
                    //console.log(el);
                    break;
                }

                modal = '';
              }
              else {
                if (el.classList.contains('chakra-toast')) {
                  switch(modal) {
                    case 'pauseConfirmClick':
                      translate(el, '.chakra-alert :nth-child(2)', 'pauseMessage')
                      break;
                    case 'resumeConfirm':
                      translate(el, '.chakra-alert :nth-child(2)', 'resumeMessage');
                      break;
                    default:
                      //console.log('toast');
                      //console.log(el);
                      break;
                  }

                  modal = '';
                }
                else if (el.classList.contains('chakra-wrap__listitem')) {
                  const button = el.querySelector('button');

                  if (button.textContent === '再開') {
                    translate(el, 'button', 'resume');
                    setModal(el, 'button', 'resume');
                  }
                  else {
                    translate(el, 'button', 'pause');
                    setModal(el, 'button', 'pause');
                  }

                  translateContract();
                }
                else {
                  //console.log('others');
                  //console.log(el);
                }
              }
            }
            else if (window.location.href.includes('/apps/floor-s/bundler')) {
              if (el.parentNode && el.parentNode.classList.contains('chakra-container')) {
                if (el.childNodes[0].classList.contains('chakra-stack')) {
                  translateBundlerFooter(el);
                }
                else {
                  translateBundler(el);
                }
              }
              else if (el.classList.contains('chakra-text')) {
                el.innerHTML = t('bundlerError');
              }
            }
            else if (window.location.href.includes('/apps/floor-s')) {
              if (el.classList.contains('chakra-container')) {
                translateList();
              }
              else {
                //console.log(el);
              }
            }
          }
        })
      });
    });

    observer.observe(document.body, { childList: true, subtree: true } );
  }

  function removeYen() {
    const productPlan = document.querySelector('.mikawaya-product-page-widget-container .mikawaya-selling-plan-price');
    if (productPlan) {
      productPlan.textContent = productPlan.textContent.replace('円', '')
    }
    else {
      setTimeout(removeYen, 200);
    }
  }

  if (window.location.href.includes('products')) {
    removeYen();
  }
})();
